/*eslint-disable*/

import { Flex, Link, List, ListItem, Text, useColorModeValue } from '@chakra-ui/react';

import { NavLink  as RouterLink } from 'react-router-dom';

import { PATH_PUBLICO, PATH_TERMS, PATH_WEBSITE } from 'const/CommonConst'

export default function Footer() {
	const textColor = useColorModeValue('gray.400', 'white');
	return (
		<Flex
			w={{ base: '100%', xl: '1170px' }}
			maxW={{ base: '90%', xl: '1170px' }}
			zIndex='1.5'
			flexDirection={{
				base: 'column',
				xl: 'row'
			}}
			alignItems={{
				base: 'center',
				xl: 'start'
			}}
			justifyContent='space-between'
			px={{ base: '0px', xl: '0px' }}
			pb='30px'
			mx='auto'>
			<Text
				color={textColor}
				textAlign={{
					base: 'center',
					xl: 'start'
				}}
				mb={{ base: '20px', xl: '0px' }}>
				{' '}
				&copy; {new Date().getFullYear()}
				<Link href={PATH_WEBSITE} target='_blank' target='_blank' fontWeight='500' ms='4px'>
					Taurel. RIF: J-00035914-8
				</Link>
			</Text>
			<List display='flex'>			
				<ListItem
					me={{
						base: '20px',
						md: '44px'
					}}>
					<Link fontWeight='500' color={textColor} as={RouterLink} to={{pathname: `${PATH_PUBLICO}${PATH_TERMS}`}}>
						Terminos y Condiciones de Uso
					</Link>
				</ListItem>
			</List>
		</Flex>
	);
}
